import { cards } from '@constants/cards'
import { getFormattedExpirationDate } from '@pages/Checkout/helpers/payment'
import { GetPaymentMethodResponse } from '@services/payments/useGetPaymentMethod'
import { Icon, Image, Paragraph, Spacer, Spreader } from '@ui-kit'
import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import { CreditCardImages } from '../CreditCardsImages'
import styles from './Details.module.scss'

interface DetailsProps {
  paymentMethodsData: GetPaymentMethodResponse
}

export const Details: FC<DetailsProps> = ({ paymentMethodsData }) => {
  const { t } = useTranslation()

  const {
    card_info: { provider, last_two_digits, expiration_date }
  } = paymentMethodsData

  const cardProvider = cards.find(({ name }) => name === provider)
  const cardNumber = `**${last_two_digits}`
  const cardExpiry = getFormattedExpirationDate(expiration_date)
  const cvv = '***'

  return (
    <div className={styles.details}>
      <Row alignItems='center' horizontal='space-between'>
        <Row>
          <Icon icon='icon-credit-card' />

          <Spreader spread={10} />

          {t('subscription.credit.card.label')}
        </Row>

        <Spreader spread={5} />

        <CreditCardImages />
      </Row>

      <Spacer space={20} />

      <div className={styles['details__cards-fields']}>
        <Column>
          <Paragraph color='neutral-6'>
            {t('registration.flow.credit.card.step.card.number')}
          </Paragraph>

          <Row>
            {cardProvider ? (
              <Fragment>
                <Image src={cardProvider.image} />

                <Spreader spread={15} />
              </Fragment>
            ) : null}

            <Paragraph size={16}>{cardNumber}</Paragraph>
          </Row>
        </Column>

        <Column>
          <Paragraph color='neutral-6'>
            {t('registration.flow.credit.card.step.expiry.date')}
          </Paragraph>

          <Paragraph size={16}>{cardExpiry}</Paragraph>
        </Column>

        <Column>
          <Paragraph color='neutral-6'>
            {t('registration.flow.credit.card.step.cvv')}
          </Paragraph>

          <Paragraph size={16}>{cvv}</Paragraph>
        </Column>
      </div>
    </div>
  )
}

Details.displayName = 'CheckoutPaymentPaymentMethodDetails'
